export const formatAndDisplayValue = (value: number, currency: string): string => {
    const formatter = new Intl.NumberFormat('tr-TR', {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 2,
    });

    return formatter.format(value);
}